import Router from 'next/router'

// Current and previous page path (incl. locale prefix and query), tracked over client side navigations.
// document.referrer alone is not enough, as it is not updated by client side navigations.
let currentPath: string | undefined
let previousPath: string | undefined

const handleRouteChangeComplete = (url: string) => {
  if (url === currentPath) return
  previousPath = currentPath
  currentPath = url
}

/**
 * Start tracking the navigation history. Call once in _app.
 * @returns Cleanup function
 */
export const trackNavigationHistory = () => {
  currentPath = `${window.location.pathname}${window.location.search}`
  Router.events.on('routeChangeComplete', handleRouteChangeComplete)
  return () => Router.events.off('routeChangeComplete', handleRouteChangeComplete)
}

/**
 * Path of the page the user came from within the shop, or undefined if the user came from another
 * site or opened the current page directly.
 */
export const getPreviousPath = (): string | undefined => {
  if (previousPath) return previousPath

  // Current page was loaded directly: use the referrer if it is a page of the shop
  try {
    const referrer = new URL(document.referrer)
    if (referrer.origin === window.location.origin) {
      return `${referrer.pathname}${referrer.search}`
    }
  } catch {
    // No or invalid referrer
  }
  return undefined
}
